import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";

import Toast from "../../../molecules/Toast";
import { parseQueryParams } from "../../../libs/Util";
import {
  Context,
  login,
  updateStudentPasswordPath,
} from "../../../studentStore";
import LoginForm from "../../../templates/student/Login/LoginForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { dispatch, state } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const location = useLocation();
  const [showMsg, setShowMsg] = React.useState({
    text: "",
    type: "",
  });
  const loginFunc = React.useCallback(
    (id: string, password: string) => {
      dispatch(peep(login(id, password)));
    },
    [dispatch, peep],
  );
  React.useEffect(() => {
    if (state.uuid) {
      history.push(`${updateStudentPasswordPath}/${state.uuid}`);
    }
  }, [history, state.uuid]);

  React.useEffect(() => {
    const message = parseQueryParams()["message"];

    if (message) {
      setShowMsg({
        text: message,
        type: "error",
      });

      const searchParams = new URLSearchParams(location.search);
      searchParams.delete("message");

      history.replace({
        pathname: location.pathname,
        search: searchParams.toString() ? `?${searchParams.toString()}` : "",
        hash: location.hash,
      });
    }
  }, [history, location.hash, location.pathname, location.search]);

  return (
    <>
      {showMsg.text && (
        <Toast
          onClose={() => setShowMsg({ text: "", type: "" })}
          message={showMsg}
        />
      )}
      <LoginForm login={loginFunc} calling={calling} />
    </>
  );
};
